import sliceCreator from '../../index.jsx';
import {GET_ALL_POST_ACTIVITIES} from '../../../constants/index.jsx';
const _getAllPostActivitiesAction = sliceCreator('GET_ALL_POST_ACTIVITIES', GET_ALL_POST_ACTIVITIES, 'get');

const { asyncAction: getAllPostActivitiesAction, reducer, clearData: clearGetAllPostActivitiesAction } = _getAllPostActivitiesAction;

export default reducer;

export {
    getAllPostActivitiesAction,
    clearGetAllPostActivitiesAction
}
